import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;

  img {
    width: 154px;
    height: 154px;
    margin-bottom: 16px;
  }

  .title {
    font: 24px Montserrat;
    max-width: 294px;
    font-weight: 500;
    line-height: 29px;
    text-align: center;
    color: #555658;
    margin-bottom: 24px;
  }

  .subtitle {
    font: 19px Montserrat;
    max-width: 320px;
    font-weight: 400;
    line-height: 26px;
    text-align: center;
    color: #898b8e;
  }

  .code {
    margin-top: 24px;
    height: 41px;
    max-width: 310px;

    font: 32px Montserrat;
    font-weight: 600;
    line-height: 26px;
    text-align: center;
    color: #555658;
  }

  @media (max-width: 900px) {
    img {
      margin-bottom: 32px;
    }

    .title {
      margin-bottom: 32px;
    }
  }
`;

export const WrapperFullHeight = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
